import React, { useState } from 'react';
import CalendarX from '../../assets/CalendarX.svg';
import { useI18n } from '../../i18n';
import './CancelMeetingModal.css';

const CancelMeetingModal = ({ isOpen, onClose, onConfirm, loading = false }) => {
    const { t } = useI18n();
    const [message, setMessage] = useState('');

    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && !loading) {
            onClose();
        }
    };

    const handleConfirm = (sendWithMessage = true) => {
        if (!loading && onConfirm) {
            onConfirm(sendWithMessage ? message : null);
        }
    };

    return (
        <div className="cancel-meeting-modal-overlay" onClick={handleBackdropClick}>
            <div className="cancel-meeting-modal">
                <button
                    className="cancel-meeting-modal-close"
                    onClick={onClose}
                    disabled={loading}
                    aria-label="Close"
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>

                <div className="cancel-meeting-modal-header">
                    <div className="cancel-meeting-modal-header-left">
                        <img src={CalendarX} alt="Cancel" className="cancel-meeting-modal-small-icon" />
                        <h2 className="cancel-meeting-modal-title">{t('pages.meetings.cancel_meeting') || 'Cancel Meeting'}</h2>
                    </div>
                </div>

                <p className="cancel-meeting-modal-description">
                    {t('pages.meetings.cancel_meeting_notification_prompt') || 'Would you like to send cancellation emails to guests?'}
                </p>

                <div className="cancel-meeting-modal-text-container">
                    <textarea
                        className="cancel-meeting-modal-textarea"
                        placeholder={t('pages.meetings.cancel_meeting_placeholder') || 'Add an optional message for cancellation...'}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        disabled={loading}
                    />
                </div>

                <div className="cancel-meeting-modal-actions">
                    <button
                        className="cancel-meeting-modal-dismiss-btn"
                        onClick={onClose}
                        disabled={loading}
                    >
                        {t('common.actions.dismiss') || 'Dismiss'}
                    </button>
                    <button
                        className="cancel-meeting-modal-dont-send-btn"
                        onClick={() => handleConfirm(false)}
                        disabled={loading}
                    >
                        {t('pages.meetings.cancel_meeting_dont_send') || "Don't Send"}
                    </button>
                    <button
                        className="cancel-meeting-modal-confirm"
                        onClick={() => handleConfirm(true)}
                        disabled={loading}
                    >
                        {loading ? (t('common.status.sending') || 'Sending...') : (t('common.actions.send') || 'Send')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelMeetingModal;
